/**
 * @author       yewon@zumper.com (Yewon Lee)
 * @copyright    Copyright (c) 2019, Zumper
 * @description  switchSetting based on the current env
 */

import { IS_LOCAL_DEV, IS_PRODUCTION } from '@zcode/env'

export const switchSetting = <PROD, POKE, LOCAL>(
  prodDefaultValue: PROD,
  pokeDefaultValue: POKE,
  localDefaultValue: LOCAL
) => {
  if (IS_PRODUCTION) {
    return prodDefaultValue
  }
  if (IS_LOCAL_DEV) {
    return localDefaultValue
  }
  return pokeDefaultValue
}
